module.exports = __webpack_public_path__ + "static/media/JamieBurns.15ba3235.png";